var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAwardedPromotions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36.2347,
    height: 35.6206,
    rx: 5.52733,
    fill: "#A855F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1265_7580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3223 12.9062H26.9373V18.5213",
    stroke: "white",
    strokeWidth: 1.84244,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9365 12.9062L19.0052 20.8375C18.874 20.9661 18.6976 21.0382 18.5139 21.0382C18.3301 21.0382 18.1537 20.9661 18.0225 20.8375L14.7939 17.6089C14.6627 17.4803 14.4863 17.4082 14.3026 17.4082C14.1188 17.4082 13.9425 17.4803 13.8112 17.6089L8.6875 22.7326",
    stroke: "white",
    strokeWidth: 1.84244,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1265_7580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.6527,
    height: 19.6527,
    fill: "white",
    transform: "translate(7.98438 7.98438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwardedPromotions);
export default __webpack_public_path__ + "static/media/Awarded Promotions.217011d6ee362ac5ddde7a1e5002b912.svg";
export { ForwardRef as ReactComponent };